import React, { useEffect, useState } from "react";
import Pagination from "../../../../../components/Pagination";
import { useAppContext } from "../../../../../context/AppContext";
import { ArticlesData } from "../../../../article/network/api/ArticlesData";
import { highlightText } from "../../../../../utils/highlight";
import CardLoader from "../../../../../components/CardLoader";
import Transition from "../../../../../components/Transition";
import Toast from "../../../../../components/Toast";
import ButtonLoader from "../../../../../components/ButtonLoader";
import { ArticleData } from "../../../network/api/ArticleData";
import { AnimatePresence } from "framer-motion";

export default function ArticleList({ setEditMode, selectedArticle, setSelectedArticle }) {
    const { appData } = useAppContext();
    const [articleList, setArticleList] = useState([]);

    const [isLoading, setIsLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState(null);
    const [articleReload, setArticleReload] = useState(false);
    const [confirmDelete, setConfirmDelete] = useState(false);

    const [toastConfig, setToastConfig] = useState({
        message: "",
        type: "primary",
    });

    const [pageProps, setPageProps] = useState({
        page: 1,
        totalPages: 1,
        totalEntries: 0,
        entryLimit: 0,
        visiblePages: []
    });

    const [pageFilters, setPageFilters] = useState({
        page: null,
        category: null,
        title: null,
        slug: null,
        limit: 10
    });

    const handleEditSwitch = (e, article = null) => {
        e.preventDefault();
        setEditMode(true);
        setSelectedArticle(article)
    }

    const handlePageChange = (page) => {
        if (page >= 1 && page <= pageProps.totalPages) {
            setPageProps((prev) => ({
                ...prev,
                page: page,
            }));

            setPageFilters((prev) => ({
                ...prev,
                page: page,
            }));
        }

    };
    const handleLimitChange = (value) => {
        setPageFilters((prev) => ({
            ...prev,
            limit: value,
        }));

    };

    const [searchValue, setSetchValue] = useState(null);
    const handleSerchChange = (e) => {
        e.preventDefault();
        const { value } = e.target;
        setSetchValue(value);

        if (value.length >= 3) {
            setPageFilters((prev) => ({
                ...prev,
                page: null,
                title: value,
                slug: value,
            }));
        }

        if (value.length === 0) {
            setPageFilters((prev) => ({
                ...prev,
                page: null,
                category: null,
                title: null,
                slug: null,
            }));
        }

    }


    const handleDeleteArticle = () => {
        setIsLoading(true);
        setTimeout(async () => {
            try {
                const response = await ArticleData({ method: "DELETE", id: selectedArticle?.id });
                if (response.status === "success") {
                    setArticleList((prevs) => prevs.filter((item) => item.id !== selectedArticle?.id));
                    document.querySelector('#deleteModalCenter .btn-close')?.click();
                    setToastConfig({ visible: true, message: `${response.message} Deleting Article ${selectedArticle?.title}`, type: response.status === "error" ? "danger" : response.status });
                } else {
                    setToastConfig({ visible: true, message: `${response.message}  Deleting Article ${selectedArticle?.title}`, type: (response.status) === "error" ? "danger" : response.status });
                }
            } catch (err) {
                setToastConfig({ visible: true, message: "Delete failed", type: "danger" });
            } finally {
                setIsLoading(false);
                setConfirmDelete(false);
            }
        }, 500);
    };


    useEffect(() => {
        const fetchArticles = async () => {
            setIsLoading(true);
            setErrorMessage(null);

            try {
                const response = await ArticlesData({ pageFilters: pageFilters, appId: appData?.id });

                if (response.status === "success") {

                    if (JSON.stringify(response.data.data) !== JSON.stringify(articleList)) {
                        setArticleList(response.data.data);
                        setPageProps({
                            page: response.data.page,
                            totalPages: response.data.total_pages,
                            totalEntries: response.data.total_records,
                            entryLimit: response.data.limit,
                            visiblePages: response.data.visible_pages,
                        })
                    }

                } else {
                    setErrorMessage({ code: response.code, message: response.message });
                }
            } catch (err) {
                setErrorMessage({ code: "500", message: "Failed to load users." });
            } finally {
                setIsLoading(false);
            }
        };
        fetchArticles();
    }, [pageFilters, appData, articleList, articleReload]);



    return (
        <>
            <AnimatePresence mode="wait">
                <Transition key={"article-list-page"}>
                    <Toast message={toastConfig.message}
                        type={toastConfig.type}
                        visible={toastConfig.visible}
                        setVisible={(visible) => setToastConfig({ ...toastConfig, visible })}
                    />
                    <div className="card custom-card">
                        {(errorMessage) && (<CardLoader errorMessage={errorMessage} onRetry={() => { setArticleReload(!articleReload); }} />)}

                        <div className="card-header">
                            <div className="d-flex justify-content-between align-items-center w-100">
                                <h4 className="card-title">Articles</h4>
                                <button className="btn btn-primary btn-sm" onClick={(e) => { handleEditSwitch(e) }} >
                                    <i className="fa fa-plus "></i> Add
                                </button>
                            </div>
                        </div>
                        <div className="card-body">

                            <div id="guestTable-all-1_wrapper" className="table-responsive dataTables_wrapper no-footer ">
                                <div className="dataTables_length" id="page_limit">
                                    <label>
                                        Show{" "}
                                        <select
                                            name="page_limit"
                                            aria-controls="example3"
                                            className=""
                                            value={pageProps.entryLimit}
                                            onChange={(e) => handleLimitChange(Number(e.target.value))}
                                        >
                                            <option value="10">10</option>
                                            <option value="25">25</option>
                                            <option value="50">50</option>
                                            <option value="100">100</option>
                                        </select>{" "}
                                        entries
                                    </label>
                                </div>
                                <div id="example3_filter" className="dataTables_filter">
                                    <label>
                                        Search:
                                        <input
                                            type="search"
                                            className=""
                                            placeholder=""
                                            aria-controls="example3"
                                            onChange={handleSerchChange}
                                        />
                                    </label>
                                </div>
                                <table className="table table-striped" style={{ minWidth: "845px" }}>
                                    <thead>
                                        <tr>
                                            <th>#</th>
                                            <th>title</th>
                                            <th>slug</th>
                                            <th>category</th>
                                            <th>updated</th>
                                            <th>Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {articleList.map((item, index) => (
                                            <tr key={index}>
                                                <td>{(pageProps.entryLimit * (pageProps.page - 1)) + (index + 1)}</td>
                                                <td><strong>{highlightText(item.title, searchValue)}</strong></td>
                                                <td><strong>{highlightText(item.slug, searchValue)}</strong></td>
                                                <td>{item.category}</td>
                                                <td>{item.updated}</td>
                                                <td>
                                                    <div className="d-flex">
                                                        <a href="/" onClick={(e) => handleEditSwitch(e, item)} className="btn btn-primary shadow btn-xs sharp me-1"><i className="fa fa-pencil-alt"></i></a>
                                                        <button
                                                            onClick={() => { setSelectedArticle(item) }}
                                                            data-bs-target="#deleteModalCenter"
                                                            data-bs-toggle="modal"
                                                            className="btn btn-danger shadow btn-xs sharp"
                                                        >
                                                            <i className="fa fa-trash"></i>
                                                        </button>
                                                    </div>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>

                                <Pagination
                                    pageProps={pageProps}
                                    onPageChange={handlePageChange} />
                            </div>
                        </div>

                    </div>
                </Transition>
                </AnimatePresence>

                <div className="modal fade" id="deleteModalCenter">
                    <div className="modal-dialog modal-dialog-centered" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Delete Article</h5>
                                <button type="button" className="btn-close" data-bs-dismiss="modal">
                                </button>
                            </div>
                            <div className="modal-body">
                                <h6>Are you sure you want to delete this <strong>{selectedArticle?.title}</strong>?</h6>
                                <p>This action will also delete all associated categories and pictures.</p>
                                <div className="form-check mt-3">
                                    <input
                                        type="checkbox"
                                        className="form-check-input"
                                        id="confirmDeleteCheck"
                                        checked={confirmDelete}
                                        onChange={(e) => setConfirmDelete(e.target.checked)}
                                    />
                                    <label className="form-check-label" htmlFor="confirmDeleteCheck">
                                        I understand the consequences of this action.
                                    </label>
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-dark light" data-bs-dismiss="modal">Cancel</button>
                                <button
                                    type="button"
                                    className="btn btn-danger"
                                    disabled={!confirmDelete || isLoading}
                                    onClick={handleDeleteArticle}
                                >
                                    {isLoading ? <ButtonLoader /> : "Delete"}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

            </>
            );
}